import { Plus } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/shadcn/button'
import { usePermissions } from '@/hooks/usePermissions'
import { PermissionEntityType } from '@/api/model'

interface Props {
  onClick: () => void
}

export function CreateCompanyButton({ onClick }: Props) {
  const { t } = useTranslation('super-admin-companies')
  const { userHasPermission } = usePermissions()
  const canCreate = userHasPermission(PermissionEntityType.AdministratorCompanies, 'Create')
  return (
    <Button className="h-9 gap-2" onClick={onClick} disabled={!canCreate}>
      <Plus className="h-4 w-4" />
      <span className="hidden sm:inline">{t('actions.create')}</span>
    </Button>
  )
}
